import React from "react"

import { H2, Paragraph } from "components/text"
import { Box } from "components/box"

export const SectionTitle: React.FC<{ title: React.ReactNode; description?: React.ReactNode }> = ({
  title,
  description
}) => (
  <Box mb={7}>
    <H2 mb={5}>{title}</H2>
    <Paragraph>{description}</Paragraph>
  </Box>
)
